/**
 * Project : workspace
 * File    : MembershipDetailsScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.membership

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp


import com.parmartechnologies.commerce.feature.customer.viewModel.CustomerViewModel
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import component.navigation.TopNavBar
import io.github.alexzhirkevich.qrose.oned.BarcodeType
import io.github.alexzhirkevich.qrose.oned.rememberBarcodePainter
import navigation.AppNavigator

/**
 * Represents the membership details screen class.
 */

class MembershipDetailsScreen {
    var authViewModel: AuthViewModel? = null
    var viewModel: CustomerViewModel? = null

    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun Content() {
        
        val customer = viewModel?.customer?.collectAsState()
        val user = authViewModel?.authUser?.collectAsState()
        LaunchedEffect(key1 = Unit) {
            if (!user?.value?.MobileNumber.isNullOrEmpty() && !user?.value?.DialCode.isNullOrEmpty()) {
                viewModel?.loadMembership(
                    mobile = user?.value?.MobileNumber!!, dialCode = user.value.DialCode
                )
            }
        }
        if (!customer?.value?.Barcode.isNullOrEmpty()) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            ) {
                TopNavBar("", onBackPress = {
                    AppNavigator.shared().goBack()
                })
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .fillMaxHeight()
                        .weight(1f)
                        .background(Color(0xFFFFFFFF), shape = RoundedCornerShape(10.dp))
                        .clip(RoundedCornerShape(10.dp))
                        .padding(20.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
//                    Icon(
//                        Icons.Default.Home,
//                        contentDescription = "Home",
//                        modifier = Modifier.weight(0.05f), tint = ThemeColor.shared().PrimaryColor
//                    )
                    Image(
                        painter = rememberBarcodePainter(customer?.value?.Barcode.toString(), BarcodeType.Code128),
                        contentDescription = "Barcode for invoice ${customer?.value?.Barcode}",
                        modifier = Modifier.fillMaxWidth().fillMaxHeight()
                    )
//                    FriendlyIcon(ImageAsset.arrowRightIcon)
                }
                Text(
                    "${customer?.value?.Barcode}",
                    modifier = Modifier.fillMaxWidth(),
                    textAlign = TextAlign.Center
                )
            }

        } else {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            ) {
                TopNavBar("", onBackPress = {
                    AppNavigator.shared().goBack()
                })
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(70.dp)
                        .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                        .clip(RoundedCornerShape(10.dp))

                        .padding(5.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    Text(
                        "No Membership found, please visit our store",
                        modifier = Modifier.weight(0.2f)
                    )
                }
            }

        }
    }

}